<template>
    <router-link to="/serial" tag="li"
        ><a
            ><i class="fa fa-pencil"></i><span>Tryout Serial</span></a
        ></router-link
    >
</template>

<script>
export default {
    name: "serial-nav",
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?2b6db40a